const InfoCircleFilled = ({ color, bgcolor, size, rotate }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      width={size || "20"}
      height={size || "20"}
      xmlns="http://www.w3.org/2000/svg"
      style={rotate ? { transform: `rotate(${rotate}deg)` } : {}}
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill={bgcolor || "#DD990A"}
      />
      <rect
        width="0.0100002"
        height="8"
        transform="translate(10 6)"
        fill={bgcolor || "#DD990A"}
      />
      <path
        d="M10 6H10.01"
        stroke={color || "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10V14"
        stroke={color || "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoCircleFilled;
